import InputWithCounter from './InputWithCounter';

export default InputWithCounter;
